import { Language } from '../../constants/enums'
import { enTranslations } from './en'
import { ruTranslations } from './ru'

export const translationsByLanguage: Record<Language, Record<string, string>> = {
  [Language.EN]: enTranslations,
  [Language.RU]: ruTranslations,
  [Language.ES]: enTranslations,
  [Language.FR]: enTranslations,
  [Language.DE]: enTranslations,
  [Language.ZH]: enTranslations,
  [Language.IN]: enTranslations,
  [Language.PT]: enTranslations,
  [Language.UNSPECIFIED]: enTranslations,
}

export function getTranslation(key: string, locale: Language): string {
  const translations = translationsByLanguage[locale] || enTranslations
  return translations[key] || key
}
